export default __webpack_public_path__ + "static/media/SubWebSchedule.81b2fa31.png";